<script>
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, email } from '@vuelidate/validators';
export default {
  components: {
    NextButton,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    displayName: {
      type: String,
      default: '',
    },
    emailEnabled: {
      type: Boolean,
      default: false,
    },
    webPhoneEmail: {
      type: String,
      default: '',
    },
    webPhonePassword: {
      type: String,
      default: '',
    },
    voipExtension: {
      type: String,
      default: '',
    },
  },
  emits: ['updateUser'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      userName: this.name,
      userDisplayName: this.displayName,
      userEmail: this.email,
      userWebPhoneEmail: this.webPhoneEmail,
      userWebPhonePassword: this.webPhonePassword,
      userVoipExtension: this.voipExtension,
      inputStyles: {
        borderRadius: '0.75rem',
        padding: '0.375rem 0.75rem',
        fontSize: '0.875rem',
        marginBottom: '0.125rem',
      },
    };
  },
  validations: {
    userName: {
      required,
      minLength: minLength(1),
    },
    userDisplayName: {},
    userEmail: {
      required,
      email,
    },
  },
  watch: {
    name: {
      handler(value) {
        this.userName = value;
      },
      immediate: true,
    },
    displayName: {
      handler(value) {
        this.userDisplayName = value;
      },
      immediate: true,
    },
    email: {
      handler(value) {
        this.userEmail = value;
      },
      immediate: true,
    },
    webPhoneEmail: {
      handler(value) {
        this.userWebPhoneEmail = value;
      },
      immediate: true,
    },
    webPhonePassword: {
      handler(value) {
        this.userWebPhonePassword = value;
      },
      immediate: true,
    },
    voipExtension: {
      handler(value) {
        this.userVoipExtension = value;
      },
      immediate: true,
    },
  },
  methods: {
    async updateUser() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        useAlert(this.$t('PROFILE_SETTINGS.FORM.ERROR'));
        return;
      }
      this.$emit('updateUser', {
        name: this.userName,
        displayName: this.userDisplayName,
        email: this.userEmail,
        webPhoneEmail: this.userWebPhoneEmail,
        webPhonePassword: this.userWebPhonePassword,
        voipExtension: this.userVoipExtension,
      });
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="updateUser('profile')">
    <woot-input
      v-model="userName"
      :styles="inputStyles"
      :class="{ error: v$.userName.$error }"
      :label="$t('PROFILE_SETTINGS.FORM.NAME.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.NAME.PLACEHOLDER')"
      :error="`${
        v$.userName.$error ? $t('PROFILE_SETTINGS.FORM.NAME.ERROR') : ''
      }`"
      @input="v$.userName.$touch"
      @blur="v$.userName.$touch"
    />
    <woot-input
      v-model="userDisplayName"
      :styles="inputStyles"
      :class="{ error: v$.userDisplayName.$error }"
      :label="$t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.PLACEHOLDER')"
      :error="`${
        v$.userDisplayName.$error
          ? $t('PROFILE_SETTINGS.FORM.DISPLAY_NAME.ERROR')
          : ''
      }`"
      @input="v$.userDisplayName.$touch"
      @blur="v$.userDisplayName.$touch"
    />
    <woot-input
      v-if="emailEnabled"
      v-model="userEmail"
      :styles="inputStyles"
      :class="{ error: v$.userEmail.$error }"
      :label="$t('PROFILE_SETTINGS.FORM.EMAIL.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.EMAIL.PLACEHOLDER')"
      :error="`${
        v$.userEmail.$error ? $t('PROFILE_SETTINGS.FORM.EMAIL.ERROR') : ''
      }`"
      @input="v$.userEmail.$touch"
      @blur="v$.userEmail.$touch"
    />
    <woot-input
      v-model.trim="userWebPhoneEmail"
      :styles="inputStyles"
      :label="$t('AGENT_MGMT.EDIT.FORM.WEB_PHONE_EMAIL.LABEL')"
      :placeholder="$t('AGENT_MGMT.EDIT.FORM.WEB_PHONE_EMAIL.PLACEHOLDER')"
    />
    <woot-input
      v-model.trim="userWebPhonePassword"
      type="password"
      :styles="inputStyles"
      :label="$t('AGENT_MGMT.EDIT.FORM.WEB_PHONE_PASSWORD.LABEL')"
      :placeholder="$t('AGENT_MGMT.EDIT.FORM.WEB_PHONE_PASSWORD.PLACEHOLDER')"
    />
    <woot-input
      v-model.trim="userVoipExtension"
      :styles="inputStyles"
      :label="$t('AGENT_MGMT.EDIT.FORM.VOIP_EXTENSION.LABEL')"
      :placeholder="$t('AGENT_MGMT.EDIT.FORM.VOIP_EXTENSION.PLACEHOLDER')"
    />
    <div>
      <NextButton type="submit" :label="$t('PROFILE_SETTINGS.BTN_TEXT')" />
    </div>
  </form>
</template>
